import { ColumnWidthLookup } from 'widgets/store/grid/columnWidth/GridColumnWidthState';
import { ColDef } from 'ag-grid-community';

export function applyColumnWidths<TColumnId extends string>(
    colDefs: ColDef[],
    columnWidths: ColumnWidthLookup<TColumnId>
) {
    for (const colDef of colDefs) {
        const width = columnWidths[colDef.colId as TColumnId];
        if (width) {
            colDef.width = width;
        }
    }
}
